import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  CircularProgress,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const DgcaBaselineHistory = ({ open, onClose, history, loading }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Baseline Configuration History</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : history.length === 0 ? (
          <Typography>No history available</Typography>
        ) : (
          <Box>
            {history.map((log) => (
              <Accordion key={log._id}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="subtitle1">
                        {log.action} - {new Date(log.createdAt).toLocaleString()}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        By: {log.actorId?.firstName} {log.actorId?.lastName} ({log.actorId?.role})
                      </Typography>
                    </Box>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" gutterBottom>Before:</Typography>
                      <pre style={{ fontSize: '0.875rem', background: '#f5f5f5', padding: '8px', borderRadius: '4px', overflow: 'auto', maxHeight: '300px' }}>
                        {JSON.stringify(log.before, null, 2)}
                      </pre>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" gutterBottom>After:</Typography>
                      <pre style={{ fontSize: '0.875rem', background: '#f5f5f5', padding: '8px', borderRadius: '4px', overflow: 'auto', maxHeight: '300px' }}>
                        {JSON.stringify(log.after, null, 2)}
                      </pre>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DgcaBaselineHistory;
